export default "__VITE_ASSET__6a3c51cf__"